import React from "react";
import Navbar from "./Navbar";

export default function Layout({ children }) {
  return (
    <div style={{ fontFamily: "Arial, sans-serif" }}>
      <Navbar />

      <div style={{ padding: "30px" }}>
        {children}
      </div>
    </div>
  );
}
